(function ($) {
	$(function () {
		setInterval(function () {
			let $videos	=	$(".videos");
			let $video	=	$videos.find(".video:last");
			let current	=	$video.children("video").get(0).currentTime;

			if(current > 0 && $videos.attr("data-mode") == "0") {
				$("#catch1").stop().fadeIn(3000);

				$videos.attr("data-mode", "1");
			}
			else if(current > 3 && $videos.attr("data-mode") == "1") {
				$("#catch1").stop().fadeOut(1000);

				$videos.attr("data-mode", "2");
			}
			else if(current > 4 && $videos.attr("data-mode") == "2") {
				$("#catch2").stop().fadeIn(2000);

				$videos.attr("data-mode", "3");
			}
			else if(current > 6 && $videos.attr("data-mode") == "3") {
				$("#catch2").stop().fadeOut(1000);

				$videos.attr("data-mode", "4");
			}
			else if(current > 7 && $videos.attr("data-mode") == "4") {
				$(".logo > .inner > dl").stop().fadeIn(1000);
				
				$videos.attr("data-mode", "5");
			}
			else if(current > 8 && $videos.attr("data-mode") == "5") {
				$(".logo .white").stop().animate({opacity: "0"}, 3000);
				$(".logo .blue").stop().fadeIn(3000);

				$videos.attr("data-mode", "6");
			}
			else if(current > 12 && $videos.attr("data-mode") == "6") {
				$(".logo > .inner").stop().animate({
					marginBottom	:	($(".logo").innerHeight() - $(".logo > .inner").innerHeight()) / 2,
				}, {
					duration	:	1500,
					complete	:	function () {
						$(this).css({margin : "auto"});
					}
				});

				$(".cover").fadeIn(1500);

				$videos.attr("data-mode", "7");
			}
			else if(current > 14 && $videos.attr("data-mode") == "7") {
				$(".logo > .inner > dl > dt > img").stop().animate({opacity: 1}, 1000);

				$videos.attr("data-mode", "8");
			}
			
			if(current > 13 && $videos.attr("data-lock") == "0") {
				let $video2	=	$videos.find(".video:first");

				$video.stop().fadeOut(2000, function () {
					$videos.prepend($video);
					$video.fadeIn(0);
					$videos.attr("data-lock", "0");
				});
				
				$video2.children("video").get(0).currentTime	=	8;
				$video2.children("video").get(0).play();

				$videos.attr("data-lock", "1");
			}
		}, 100);
	});
})(jQuery);